<template>
  <div class="contents">
    <div class="opt">
      <div class="search">
        <el-popover
          ref="popover"
          placement="top"
          class="searchPop"
          title="批量搜索"
          trigger="click"
          width="378"
        >
          <div class="close" @click="closeSearchPanel">
            <i class="el-icon-close"></i>
          </div>
          <base-muti-input
            ref="baseMutiInput"
            v-model="referenceNumber"
            :isAutoWrap="false"
          ></base-muti-input>
          <div style="text-align: right; margin: 16px 0 0">
            <el-button size="small" @click="handleEmpty">清空</el-button>
            <div
              class="sure"
              @mousedown="handleConfirm"
            >确定</div
            >
          </div>
        </el-popover>
        <el-input
          :value="searchVal"
          placeholder="请输入税号搜索"
          class="input-search"
          @focus="handleFocus"
        ></el-input>
        <div class="btn-search" @click="handleConfirm">
          <i class="el-icon-search"></i>
        </div>
      </div>
      <div v-permissson="'add'" class="add flex_c_c" @click="add">
        <svg-icon
          v-permissson="'add'"
          className="icon"
          iconClass="add" /> 新增
      </div>
      <div class="add flex_c_c" style="margin-left: 10px;" @click="downloadFile">
        <svg-icon
          className="icon"
          iconClass="download" /> 导出
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="tableData"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :loading="loading"
        :isPager="true"
        :isEmptyBorder="true"
        @sortChange="sortChange"
        @handlePageChange="handlePageChange"
      >
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-permissson="'update'"
                  class="opt-item"
                  @click="handleEdit(row.scope)"
                >修改</el-button
                >
                <el-button
                  v-permissson="'delete'"
                  class="opt-item"
                  @click="handleDelete(row.scope)"
                >删除</el-button
                >
              </div>
            </div>
            <img
              slot="reference"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
        </template>
      </BaseTable>
    </div>
    <TaxAddDialog
      :dialogVisible="dialogVisible"
      :editData="editData"
      @cancel="cancel"
      @ok="ok"
    >
    </TaxAddDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseMutiInput = () => import('@/components/base/BaseMutiInput')
import { getTaxRatePage, deleteTaxRate } from '@/api/basic'
import { derive } from '@/utils/common'
const TaxAddDialog = () => import('@/components/dialog/TaxAddDialog')
import { myMixins } from '@/mixins'
export default {
  name: 'TaxRate',
  components: { BaseTable, BaseMutiInput, TaxAddDialog },
  mixins: [myMixins],
  data() {
    return {
      tableData: {
        fileds: [{
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'hsCode',
            label: '税号',
            width: '110',
            isSort: true
          },
          {
            filed: 'originCountry',
            label: '原产国',
            width: '60'
          },
          {
            filed: 'baseRate',
            label: '基础税率',
            width: '70',
            formatter: (row) =>
              row.baseRate ? `${row.baseRate}%` : ''
          },
          {
            filed: 'addRate',
            label: '批次/税率(301)',
            width: '130',
            formatter: (row) =>
              row.addRate ? `${row.batchNo + '/'}${row.addRate}%` : ''
          },
          {
            filed: 'addRateTwo',
            label: '批次/税率(122)',
            width: '120',
            formatter: (row) =>
              row.addRateTwo ? `${row.batchNoTwo + '/'}${row.addRateTwo}%` : ''
          },
          {
            filed: 'addRateThree',
            label: '批次/税率(钢铝)',
            width: '120',
            formatter: (row) =>
              row.addRateThree ? `${row.batchNoThree + '/'}${row.addRateThree}%` : ''
          },
          {
            filed: 'addRateFour',
            label: '批次/税率(半导体)',
            width: '120',
            formatter: (row) =>
              row.addRateFour ? `${row.batchNoFour + '/'}${row.addRateFour}%` : ''
          },
          {
            filed: 'addRateFive',
            label: '批次/税率(轻型汽配)',
            width: '130',
            formatter: (row) =>
              row.addRateFive ? `${row.batchNoFive + '/'}${row.addRateFive}%` : ''
          },
          {
            filed: 'addRateSix',
            label: '批次/税率(铜)',
            width: '100',
            formatter: (row) =>
              row.addRateSix ? `${row.batchNoSix + '/'}${row.addRateSix}%` : ''
          },
          {
            filed: 'addRateSeven',
            label: '批次/税率(木质)',
            width: '110',
            formatter: (row) =>
              row.addRateSeven ? `${row.batchNoSeven + '/'}${row.addRateSeven}%` : ''
          },
          {
            filed: 'addRateEight',
            label: '批次/税率(中&重汽配)',
            width: '140',
            formatter: (row) =>
              row.addRateEight ? `${row.batchNoEight + '/'}${row.addRateEight}%` : ''
          },
          {
            filed: 'tax',
            label: '总税率',
            width: '80',
            formatter: (row) => {
              return `${+(row.baseRate || 0) + +(row.addRate || 0) + +(row.addRateTwo || 0) + +(row.addRateThree || 0) + +(row.addRateFour || 0) + +(row.addRateFive || 0) + +(row.addRateSix || 0) + +(row.addRateSeven || 0) + +(row.addRateEight || 0)}%`
            }
          },
          {
            filed: 'createdOn',
            label: '创建时间',
            width: '100',
            formatter: (row) => {
              return row.createdOn.slice(0, 11)
            }
          },
          {
            filed: 'remark',
            label: '备注',
            width: ''
          }
        ],
        columns: [],
        total: 0
      },
      loading: false,
      filterList: {},
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      sortable: {
        sortField: undefined,
        sortBy: undefined
      },
      referenceNumber: '',
      searchVal: '',
      dialogVisible: false,
      editData: {},
      height: 0
    }
  },
  created() {
    this.getList(this.pager)
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
  },
  methods: {
    async getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.sortable,
            hsCode: this.searchVal ? this.searchVal.split(';') : undefined
          }
        }
        const res = await getTaxRatePage(params)
        if (res.success) {
          this.loading = false
          this.tableData.columns = res.data.list
          this.tableData.total = res.data.total
        } else {
          this.loading = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    handleEdit(row) {
      this.editData = row
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(() => {
          deleteTaxRate({
            id: row.id
          }).then((res) => {
            if (res.success) {
              this.$message.success('删除成功')
              this.initList()
            } else {
              this.$message.error(res.errorMessage)
            }
          })
        })
        .catch(() => {})
    },
    sortChange(params) {
      console.log('params', params)
      this.sortable.sortField = params.prop || undefined
      this.sortable.sortBy =
        params.order === undefined ? undefined : params.order
      this.getList(this.pager)
    },
    closeSearchPanel() {
      this.handleConfirm()
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.searchVal = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.initList()
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
      if (this.referenceNumber && this.referenceNumber !== '') {
        this.searchVal = this.referenceNumber.join(';')
      }
      this.$refs.popover.doClose()
      this.initList()
    }, 0)
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    add() {
      this.dialogVisible = true
    },
    ok() {
      this.cancel()
      this.initList()
    },
    initList() {
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = params
      this.getList(params)
    },
    cancel() {
      this.dialogVisible = false
      this.editData = {}
    },
    handlePageChange(pager) {
      this.pager = {
        ...pager
      }
      this.getList(pager)
      console.log('pager', pager)
    },
    async downloadFile() {
      this.loading = true
      await derive('TaxRate/exportTaxRate', 'post', { hsCode: this.searchVal ? this.searchVal.split(';') : undefined })
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.contents {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
}
.opt {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
  .search {
    position: relative;
    display: flex;
    width: 200px;
    margin-right: 8px;
    .searchPop {
      /deep/ .el-popover {
        z-index: 9999;
        right: 0;
      }
      .close {
        position: absolute;
        top: 6px;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
    }
    .input-search {
      width: 166px;
      height: 30px !important;
      /deep/ .el-input__inner {
        height: 30px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .btn-search {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      border: 1px solid #dbe4f2;
      border-left: 0;
      border-radius: 0 4px 4px 0;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
}
.add {
  width: 84px;
  height: 30px;
  background:  rgb(18,88,188);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  svg {
    font-size: 20px;
  }
}
.data {
  width: 100%;
  height: calc(100% - 54px);
  z-index: 1;
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
  &:deep(.el-button) + .el-button {
    margin-left: 30px;
  }
  &:deep(.el-button--text) {
    padding: 0;
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #FFF;
  border: 1px solid #DCDFE6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
  margin-left: 10px
}
</style>
